import { useEffect } from "react";
import "./style.css";
import { useState } from "react";
import {
  GetBudgetDetails,
  SetBudgetDetails,
} from "../../../Redux/Reducers/BudgetInformation/BudgetDetails";
import { useDispatch, useSelector } from "react-redux";
import loadConfig from "../../../Services/apiService";
import InputAHSF from "../../../Components/InputAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
import { useParams } from "react-router-dom";
const DetailsBudget = () => {
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      BudgetDetails: state.BudgetDetails?.BudgetDetails,
      loadingBudgetDetails: state.BudgetDetails?.loadingBudgetDetails,
    };
  });
  const dispatch = useDispatch();
  const AppGuid = useParams();

  // Function to add thousand separators to a number
  const numberWithCommas = (x) => {
    if (x == null || isNaN(x)) {
      return ""; // Return an empty string or handle the invalid input as needed
    }
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const [dataJsonObject, SetDataJsonObject] = useState();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };

  //save data on state budgetDetails
  const [budgetDetails, setBudgetDetails] = useState({
    ...state.BudgetDetails,
  });

  useEffect(() => {
    // Dispatch an action to fetch budget details using the application information ID
    dispatch(
      GetBudgetDetails(
        state.ApplicationInformation.aI_ApplicationInformationId ||
        decryptToken(AppGuid.AppGuid) // Decrypt the AppGuid if application ID is not available
      )
    );
  }, []); // This effect runs only once when the component mounts
  
  useEffect(() => {
    // Update the local state with budget details once they are fully loaded
    if (!state.loadingBudgetDetails) {
      setBudgetDetails({ ...state.BudgetDetails });
    }
  }, [state.loadingBudgetDetails]); // Effect runs whenever the budget loading state changes
  
  useEffect(() => {
    // Dispatch an action to update the Redux state with the current budget details
    dispatch(SetBudgetDetails({ ...budgetDetails }));
  }, [budgetDetails]); // Effect runs whenever the local `budgetDetails` state changes
  
  //render html

  return (
    <div className="form-grid">
      <InputAHSF
        fieldsName="Estimatedbudget"
        show={true}
        disabled={true}
        value={numberWithCommas(state.BudgetDetails?.totalEstimatedBudget)}
      />
      <InputAHSF
        fieldsName="Requiredcontribution"
        show={true}
        disabled={true}
        value={numberWithCommas(
          state.BudgetDetails?.totalValueContributionShoman
        )}
      />
      <InputAHSF
        fieldsName="AdvancedContribution"
        show={true}
        disabled={true}
        value={numberWithCommas(
          state.BudgetDetails?.totalValueContributionBeneficiary
        )}
      />
      <InputAHSF
        fieldsName="acCostbalancing"
        show={true}
        disabled={true}
        value={
          Number(
            state.BudgetDetails
              ?.ratioTotalAdministrativeCostsSchumancontributionTotalBudgetDirectCostsSchumanContribution
          ).toFixed(2) + "%"
        }
      />
      <InputAHSF
        fieldsName="Directcosts"
        show={true}
        disabled={true}
        value={numberWithCommas(
          state.BudgetDetails?.totalBudgetdirectCostsAbdulHameedShomanFoundation
        )}
      />
      <InputAHSF
        fieldsName="Costbalancing"
        show={true}
        disabled={true}
        value={numberWithCommas(
          state.BudgetDetails?.theBudgetAdministrativeCostsShoman
        )}
      />

      <InputAHSF
        fieldsName="Submittedcontribution"
        show={true}
        disabled={true}
        value={
          Number(
            state.BudgetDetails
              ?.percentageTotalValueContributionProvidedBeneficiary
          ).toFixed(2) + "%"
        }
      />
      <LoaderAHSF show={state.loadingBudgetDetails} />
    </div>
  );
};

export default DetailsBudget;
